// Components, Layouts, Pages
import {
  CourseDetailPageStudent,
  DashboardPageStudent,
  EducationalProgramPageStudent,
  TuitionFeesPageStudent,
} from '~/pages/student';
import { IRouteModel } from '~/utils/interface/base';
// Others
// Styles, images, icons

export const studentRoute = {
  base: '/student',
  course: '/course',
  tuitionArea: '/tuition-area',
  examArea: '/exam-area',
  module: '/module',
  courseDetail: '/:courseId',
  moduleDetail: '/:moduleId',

  // Common
  commonCreate: '/create',
  commonDetail: '/:id',
};

export const privateStudentRoutes: IRouteModel[] = [
  {
    index: true,
    path: `${studentRoute.base}`,
    component: DashboardPageStudent,
    name: 'Dashboard',
  },
  {
    index: true,
    path: `${studentRoute.base}${studentRoute.course}${studentRoute.courseDetail}${studentRoute.module}${studentRoute.moduleDetail}`,
    component: CourseDetailPageStudent,
    name: 'CourseDetail',
  },
  {
    index: true,
    path: `${studentRoute.base}${studentRoute.tuitionArea}`,
    component: TuitionFeesPageStudent,
    name: 'TuitionFees',
  },
  {
    index: true,
    path: `${studentRoute.base}${studentRoute.examArea}`,
    component: EducationalProgramPageStudent,
    name: 'EducationalProgram',
  },
];

export const studentRouteAbsolute = {
  dashboard: `${studentRoute.base}`,
};
